import { logUsage } from 'owa-analytics';
import type { CustomData } from 'owa-analytics-types';
import type { MailboxInfo } from 'owa-client-types';

/**
 * @function
 * To log Info, errors, exceptions and performance metrics through log telemetry request
 * from external renderer dependencies like me-renderer, office-start
 */
export const logTelemetry = (
    eventName: string,
    miscData: CustomData,
    mailboxInfo: MailboxInfo
): void => {
    // Preserve the original dynamic event name in the payload
    const dataWithDynamicName = {
        DynamicEventName: eventName,
        ...miscData,
    };

    // Message extension telemetry from external renderer
    logUsage('Message_Extension_Event', mailboxInfo, dataWithDynamicName);
};
